import Header from '../components/Header';
import Team from '../components/Team';
import Footer from '../components/Footer';

const TeamPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main>
        <Team />
      </main>
      <Footer />
    </div>
  );
};

export default TeamPage;